import { useEffect, useState } from 'react';

/**
 * Hoe lang de stap die nu loopt al bezig is, in seconden.
 *
 * Nodig omdat niet elke stap eigen voortgang heeft. Het uitschrijven telt
 * tekens, maar het omzetten levert niets tussentijds op: daar is een oplopende
 * teller het enige dat laat zien dat er iets gebeurt. Een stilstaand getal leest
 * als een vastloper, en dat is precies de klacht waar dit voor bestaat.
 *
 * Telt vanaf een tijdstip dat de server meestuurt (`sinds`) en niet vanaf het
 * moment dat dit scherm opende. Anders springt de teller terug naar nul zodra
 * de buddy de pagina ververst, terwijl de verwerking gewoon doorliep.
 */
export function useVerstrekenTijd(sinds: string | null | undefined): number {
  const [nu, setNu] = useState(() => Date.now());

  useEffect(() => {
    if (!sinds) return;
    setNu(Date.now());
    const tik = window.setInterval(() => setNu(Date.now()), 1000);
    return () => window.clearInterval(tik);
  }, [sinds]);

  if (!sinds) return 0;
  const begin = Date.parse(sinds);
  if (Number.isNaN(begin)) return 0;
  // Een klok die achterloopt op die van de server mag geen negatief getal geven.
  return Math.max(0, Math.floor((nu - begin) / 1000));
}
